import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import axios from 'axios';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Articles from './pages/Articles';
import WebsitesPage from './pages/WebsitesPage';
import Contact from './pages/Contact';

function App() {
  const [portfolioData, setPortfolioData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/api/portfolio.json');
        setPortfolioData(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching portfolio data:', err);
        setError('Failed to load portfolio data. Please try again later.');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <h1 className="text-2xl text-red-500 mb-4">Error</h1>
        <p className="text-gray-300">{error}</p>
        <button 
          onClick={() => window.location.reload()}
          className="mt-6 btn-primary"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home portfolioData={portfolioData} />} />
          <Route path="/projects" element={<Projects projects={portfolioData?.projects || []} />} />
          <Route path="/projects/:id" element={<ProjectDetail projects={portfolioData?.projects || []} />} />
          <Route path="/articles" element={<Articles articles={portfolioData?.articles || []} />} />
          <Route path="/websites" element={<WebsitesPage websites={portfolioData?.websites || []} />} />
          <Route path="/contact" element={<Contact about={portfolioData?.about || {}} />} />
        </Routes>
      </main>
      <Footer about={portfolioData?.about || {}} />
    </div>
  );
}

export default App;